export default __webpack_public_path__ + "static/media/payment.a3b5b243.svg";